@import '../../../../themes/site/default/assets/common_helpers_non_liquid.scss';
@import '../../../../themes/site/default/assets/font_helpers.scss';
@import '../../../../themes/site/default/assets/responsive_helpers.scss';

.section--testimonials {
  .testimonial__row {
    margin-top: 20px;

    @media (min-width: $post-small) {
      @include display-flex;
    }

    .testimonial__clearfix {
      @media (min-width: $medium) {
        display: none;
      }
    }
  }

  .testimonial__row--default {
    .testimonial {
      @include flex(1);
      background-color: white;
      @include border-radius(5px);
      margin: 0.5rem;
      padding: 1rem;

      .testimonial__image {
        position: relative;
      }
    }
  }

  .testimonial__row--alternate {
    .testimonial {
      @include flex(1);
      margin: 0.5rem;
      padding: 1rem;
      display: flex;
      flex-direction: column;
      justify-content: center;
      align-items: center;
      gap: 20px;

      .testimonial__image {
        position: relative;
      }

      .testimonial__details {
        .testimonial__name {
          font-weight: bold;
        }
        .testimonial__title {
          font-style: normal;
        }
      }
    }
  }

  .section__header-text {
    text-align: center;
  }

  .testimonial__slider {
    overflow: hidden;

    .testimonial__quote {
      font-size: 1.25rem;
      margin: 0 auto 2rem;
    }

    .testimonial__quote,
    .testimonial__name,
    .testimonial__title {
      padding: 0 3rem;
    }

    &--slider_alternate_4 {
      overflow: visible;
      .flex-control-nav {
        margin-bottom: -25px;
        &.flex-control-paging li a.flex-active {
          background-color: var(--quote-icon-color) !important;
        }
      }

      .quote-icon {
        margin-bottom: 32px;
      }

      .name-container {
        display: flex;
        gap: 20px;
        align-items: center;
        justify-content: center;
        .testimonial__image {
          margin: 0;
        }
      }
    }

    &--slider_alternate_3 {
      border-bottom: 1px solid black;
      padding-bottom: 80px;

      .flex-next,
      .flex-prev {
        width: 50px;
        height: 50px;
        display: flex;
        align-items: center;
        justify-content: center;
      }
      .flex-prev {
        transform: rotate(180deg);
      }
      li.testimonial {
        gap: 32px;
        display: flex !important;
        flex-direction: column;
        align-items: center;
        p {
          margin: 0;
        }
      }

      @media (max-width: 480px) {
        .flex-direction-nav {
          margin-top: 20px;
          display: flex;
          height: 100px;
          justify-content: center;
          gap: 24px;

          .flex-nav-prev,
          .flex-nav-next {
            width: 50px;
            display: flex;

            align-items: center;
          }
          a {
            position: relative;
            left: unset !important;
            right: unset !important;
            top: unset !important;
            margin: unset !important;
          }
        }
      }
    }

    &--alternate {
      .testimonial__image__container {
        display: inline-block;
        position: relative;
        line-height: 0;
      }
      .testimonial__image__quote-circle {
        position: absolute;
        right: -9px;
        bottom: -3px;
        padding: 13px;
        border-radius: 100%;
        background: var(--color-primary);
        color: var(--color-body);
        box-shadow: 0px 6px 10px rgba(var(--color-primary), 0.25);
      }
      .testimonial {
        margin-bottom: 20px;
      }
      .testimonial .testimonial {
        &__image {
          margin-bottom: 0rem;
        }
        &__quote {
          margin-top: 30px;
          margin-bottom: 30px;
          font-size: 18px;
          color: var(--color-heading);
        }

        &__name {
          margin-top: 6px;
          font-size: 16px;
          font-weight: bold;
          color: var(--color-heading);
        }

        &__title {
          font-style: normal;
          font-size: 16px;
          opacity: 1;
        }
      }
      .flex-control-paging {
        > li > a {
          height: 8px;
          width: 8px;
          margin: 0px 8px;
          background: #b0bacb;
          &.flex-active {
            background: var(--color-primary);
          }
        }
      }
    }

    &--alternate-2 {
      margin-bottom: 0;

      .testimonial {
        @include below-tablet-lg {
          text-align: left;
        }

        .testimonial__quote,
        .testimonial__name,
        .testimonial__title {
          max-width: 920px;
        }

        .testimonial__name,
        .testimonial__title {
          font-style: normal;
          text-align: left;
          padding-right: 0;
          padding-left: 12px;

          @include tablet-lg {
            padding-left: 24px;
          }
        }

        .testimonial__quote {
          font-weight: 600;
          @include responsive-font-size(12px, 14px, 18px, 22px, 24px);

          @include below-tablet-lg {
            padding: 0 42px;
          }
        }

        .testimonial__author-container {
          display: inline-flex;
          align-items: center;

          @include below-tablet-lg {
            padding: 0 42px;
          }
        }

        .testimonial__image {
          margin-bottom: 0px;
          @include below-tablet-lg {
            max-height: 42px;
            width: auto !important;
          }
        }
      }

      .flex-prev,
      .flex-next {
        svg {
          height: auto;
          width: 8px;

          @include tablet-lg {
            width: 12px;
          }
        }
      }

      .flex-prev {
        left: 0;
      }

      .flex-next {
        right: 0;
      }

      .flex-control-paging {
        display: none;
      }
    }
  }

  .testimonial {
    text-align: center;

    .testimonial__image {
      margin: 0 auto 0.5rem;
      @include border-radius(100%);
      picture,
      img {
        @include border-radius(100%);
      }
    }

    .testimonial__quote,
    .testimonial__name,
    .testimonial__title {
      margin-left: auto;
      margin-right: auto;
      max-width: 800px;
    }

    .testimonial__link {
      display: block;
    }

    .testimonial__name {
      margin-bottom: 0;
    }

    .testimonial__title {
      font-size: 0.875rem;
      font-style: italic;
      opacity: 0.6;
    }
  }

  .testimonial__microdata {
    display: none;
  }

  &--testimonial-style-alternate-2 {
    .wrapper {
      padding-left: 24px;
      padding-right: 24px;

      @include tablet {
        padding-left: 36px;
        padding-right: 36px;
      }

      @include tablet-lg {
        padding-left: 48px;
        padding-right: 48px;
      }

      @include desktop {
        padding-left: 64px;
        padding-right: 64px;
      }

      @include desktop-lg {
        padding-left: 92px;
        padding-right: 92px;
      }

      @include desktop-xl {
        padding-left: 145px;
        padding-right: 145px;
      }
    }
  }
}

.testimonial_staggered_cards {
  display: flex;
  align-items: center;
  flex-direction: column;
  --offset: -240px;

  > :nth-child(odd) {
    margin-left: var(--offset);
  }
  > :nth-child(even) {
    margin-right: var(--offset);
  }

  .testimonial {
    &:not(:first-child) {
      margin-top: -20px;

      &:has(.testimonial__image) {
        margin-top: -10px;
      }
    }
    background-color: var(--box_color);
    display: flex;

    gap: 20px;
    width: fit-content;
    width: 540px;
    padding: 32px;
    box-shadow: 0 0 40px rgba(0, 0, 0, 0.5);
    text-align: start;
    border-radius: 20px;

    img {
      margin: 0 0 0 !important;
    }
    .content {
      display: flex;
      align-items: flex-start;
      flex-direction: column;
      gap: 20px;

      .testimonial__details {
        display: flex;
        align-items: flex-start;
        flex-direction: column;

        .testimonial__title {
          font-weight: normal !important;
          font-style: normal !important;
          opacity: 1 !important;
        }

        .testimonial__name {
          margin: 0;
          font-weight: bold;
        }
      }
      p {
        margin-bottom: 0;
      }
    }
  }

  @media (max-width: 1100px) {
    --offset: -300px;
  }

  @media (max-width: 1000px) {
    --offset: -200px;

    .testimonial {
      &:not(:first-child) {
        margin-top: -20px;
      }
      width: 500px;
    }
  }

  @media (max-width: 700px) {
    --offset: -100px;
  }

  @media (max-width: 620px) {
    --offset: -50px;

    .testimonial {
      &:not(:first-child) {
        margin-top: -10px;
      }
      width: 310px;
    }
  }
}
